import React from "react";
import Input from "../../components/input/input-component";
import "./login.css";
import Container from "../../components/container/container-component";
import Button from "../../components/button/button-component";

const LoginComponent = ({ username, password, inputChange, login, loading, error }) => {
  return (
    <Container justifyContent="center" alignItems="center" flexDirection="column">
      <form style={{ width: "38%" }} onSubmit={e => {
        e.preventDefault();
        login();
      }}>
        <Input
          name={username.name}
          value={username.value}
          error={username.error}
          type={username.type}
          nameFontSize="16px"
          inputFontSize="18px"
          inputChange={e => inputChange({value: e.target.value, field: 'username'})}
        />
        <Input
          name={password.name}
          value={password.value}
          error={password.error}
          type={password.type}
          nameFontSize="16px"
          inputFontSize="18px"
          inputChange={e => inputChange({value: e.target.value, field: 'password'})}
        />
        <div className="login__error" >{error}</div>
        <div className="login__btn">
          <Button
            name="Login"
            type="submit"
            primaryBtn
            async
            loading={loading}
            width="30%"
            height="50px"
            spinnerRight="18px"
            spinnerTop="17px"
          />
        </div>

      </form>
    </Container>
  );
};

export default LoginComponent;



// WEBPACK FOOTER //
// ./src/modules/login/login-component.js